import $ from "jquery";
import { getDefaultOptions } from "./fetch";
import { callMdaePublicApi } from "../call-web-api";
import { BASE_API_URL } from "../constants/url";
import jszip from "jszip";
import {
  TOGGLE_WAIT_TIME_MESSAGE_POPUP,
} from "../common_components/document-management/reducers/document-management-reducer";
import { Cookie } from "../angular-app-handlers";
import {
  setProgressBarLoaderPopupValue as setProgressBarLoaderPopupValueMain,
  toggleProgressBarLoaderPopupVisible as toggleProgressBarLoaderPopupVisibleMain,
} from "../common_components/common_widgets/progress-load-indicator/component";
import * as XLSX from "xlsx";
export function NewInstance() {
  const defaultUploaddParamObjet = {
    urlValidTimeSpan: 0,
    partSize: 0,
    uploadId: null,
    partETags: [],
    currentPartIndex: 0,
    currentPartNumber: 0,
    type: "PUT",
    uploadUrl: null,
    fileParts: [],
    requestVerb: null,
    s3ObjectName: null,
  };
  var waitTimeSetupConfig = {
    maxWaitTime: 20,
    currentWaitTime: 0,
    waitTimeInterval: null,
  };
  var uploadParamObject: { [key: string]: any } = {};
  const toggleProgressBarLoaderPopupVisible = (
    isVisible,
    progressLoadIndicatorProgressText = "Uploading"
  ) => {
    toggleProgressBarLoaderPopupVisibleMain(
      progressBarSettings.dispatch,
      isVisible,
      progressLoadIndicatorProgressText
    );
  };
  const setProgressBarLoaderPopupValue = (progressLoadIndicatorValue) => {
    setProgressBarLoaderPopupValueMain(
      progressBarSettings.dispatch,
      progressLoadIndicatorValue
    );
    if(typeof uploadParamObject.setUploadProgress === "function")
      uploadParamObject.setUploadProgress(progressLoadIndicatorValue);
  };
  
  function resetUploadParams() {
    uploadParamObject = JSON.parse(JSON.stringify(defaultUploaddParamObjet));
  }
  function setUploadParamObject(valueObject) {
    uploadParamObject.urlValidTimeSpan = valueObject.urlValidSeconds;
    uploadParamObject.partSize = valueObject.partSize;
    uploadParamObject.uploadId = valueObject.uploadId;
    uploadParamObject.uploadUrl = valueObject.uploadUrl;
  }
  function getPresignedUploadUrl() {
    return new Promise<void>(function(resolve, reject) {
      callMdaePublicApi({
        url: "/private/v1/documents/presignedurl",
        type: "POST",
        ...getDefaultOptions(),
        body: JSON.stringify({
          s3ObjectName: uploadParamObject.s3ObjectName,
          contentType: uploadParamObject.contentType,
          partNumber: uploadParamObject.currentPartNumber
            ? parseInt(uploadParamObject.currentPartNumber)
            : 0,
          tags: uploadParamObject.tags,
          uploadId: uploadParamObject.uploadId,
          Verb: uploadParamObject.requestVerb,
          originalFileName: uploadParamObject.originalFileName,
          fileSize: parseInt(
            (uploadParamObject.totalFileSize / (1024 * 1024)).toString()
          ), // IN MB
        }),
      })
        .then(function(responseData: any) {
          responseData.data.partSize = responseData.data.partSize * 1024 * 1024;
          setUploadParamObject(responseData.data);
          resolve();
        })
        .catch(function() {
          resolve();
        });
    });
  }
  function getDividedParts(blobFile) {
    var partNum = 0;
    var fileParts = [];
    for (
      var rangeStart = 0;
      rangeStart < blobFile.size;
      rangeStart += uploadParamObject.partSize
    ) {
      partNum++;
      var end = Math.min(rangeStart + uploadParamObject.partSize, blobFile.size),
        partParams = {
          body: new File([blobFile.slice(rangeStart, end)], blobFile.name, {
            type: blobFile.type,
          }),
          partNumber: partNum,
        };
      fileParts.push(partParams);
    }
    return fileParts;
  }
  const uploadFile = function(
    blobFile,
    s3ObjectName,
    documentId,
    documentName,
    attachedLevelName,
    attachedLevelId,
    dispatch,
    tags = null,
    enableProgressBar = true,
    setUploadProgress = null
  ) {
   
    return new Promise<boolean>(function(resolve, reject) {
      blobFile = new File([blobFile], s3ObjectName, { type: blobFile.type });
      resetUploadParams();
      uploadParamObject.s3ObjectName = s3ObjectName;
      uploadParamObject.totalFileSize = blobFile.size;
      uploadParamObject.contentType = blobFile.type;
      uploadParamObject.documentId = documentId;
      uploadParamObject.documentName = documentName;
      uploadParamObject.attachedLevelName = attachedLevelName;
      uploadParamObject.attachedLevelId = attachedLevelId;
      progressBarSettings.dispatch = dispatch;
      uploadParamObject.dispatch = dispatch;
      uploadParamObject.requestVerb = "PUT";
      uploadParamObject.tags = tags;
      uploadParamObject.enableProgressBar = enableProgressBar;
      uploadParamObject.setUploadProgress = setUploadProgress;
      showProgressBar();
      setupWaitTime();
      getPresignedUploadUrl().then(function() {
        var fileUploadPromise;
        if (uploadParamObject.uploadUrl) {
          if (uploadParamObject.uploadId) {
            uploadParamObject.fileParts = getDividedParts(blobFile);
            uploadParamObject.currentPartIndex = 0;
            fileUploadPromise = uploadMultipleParts();
          } else {
            fileUploadPromise = uploadPart(blobFile);
          }
          fileUploadPromise.then(function(isFileUploaded) {
            deleteWaitTimeSetup();
            if (isFileUploaded) {
              completeFileUpload().then(function() {
                deleteWaitTimeSetup();
                hideProgressBar();
                resolve(true);
              });
            } else {
              cancelFileUpload().then(function() {
                deleteWaitTimeSetup();
                hideProgressBar();
                resolve(false);
              });
            }
          });
        } else {
          resolve(false);
          hideProgressBar();
          alert("File upload failed");
        }
      });
    });
  };
  
  function uploadPart(uploadBody) {
    var getUploadUrlPromise = new Promise<void>(function(resolve, reject) {
      if (
        uploadParamObject.currentPartNumber == 1 ||
        !uploadParamObject.uploadId
      ) {
        resolve();
      } else {
        getPresignedUploadUrl().then(function() {
          resolve();
        });
      }
    });
    var isPartUploaded = false;
    return new Promise<boolean>(function(resolve, reject) {
      getUploadUrlPromise.then(function() {
        $.ajax({
          url: uploadParamObject.uploadUrl,
          type: "PUT",
          data: uploadBody,
          processData: false,
          contentType: false,
          beforeSend: function(xhr) {
            if (uploadParamObject.tags) {
              const tagsString = Object.entries(uploadParamObject.tags)
                .map(([key, value]) => `${key}=${value}`)
                .join("&");
              if (tagsString) {
                xhr.setRequestHeader("x-amz-tagging", tagsString);
              }
            }
          },
          success: function(data, status, response) {
            var eTag = JSON.parse(response.getResponseHeader("ETag"));
            uploadParamObject.partETags.push({
              eTag: eTag,
              partNumber: uploadParamObject.currentPartNumber,
            });
            isPartUploaded = true;
          },
          error: function(e) {
            console.log(e);
          },
        }).always(function() {
          resolve(isPartUploaded);
        });
      });
    });
  }
  
  var uploadMultipleParts = function() {
    return new Promise<boolean>(function(resolve, reject) {
      uploadParamObject.currentPartNumber =
        uploadParamObject.fileParts[
          uploadParamObject.currentPartIndex
        ].partNumber;
      uploadPart(
        uploadParamObject.fileParts[uploadParamObject.currentPartIndex].body
      ).then(function(isPartUploaded) {
        uploadParamObject.currentPartIndex++;
        showProgressBar();
        if (
          uploadParamObject.currentPartIndex < uploadParamObject.fileParts.length
        ) {
          uploadMultipleParts().then(function() {
            resolve(isPartUploaded);
          });
        } else {
          resolve(isPartUploaded);
        }
      });
    });
  };
  
  function completeFileUpload() {
    var isCompleted = false;
    var completeParams: { [key: string]: any } = {};
    completeParams.uploadId = uploadParamObject.uploadId;
    completeParams.partETags = uploadParamObject.partETags;
    completeParams.s3ObjectName = uploadParamObject.s3ObjectName;
    completeParams.documentId = uploadParamObject.documentId;
    completeParams.documentName = uploadParamObject.documentName;
    completeParams.attachedLevelName = uploadParamObject.attachedLevelName;
    completeParams.attachedLevelId = uploadParamObject.attachedLevelId;
    return new Promise<boolean>(function(resolve, reject) {
      callMdaePublicApi({
        url: "/Api/Document/CompleteDocumentUpload",
        type: "POST",
        ...getDefaultOptions(),
        isRoutedApiCall: true,
        body: JSON.stringify(completeParams),
      })
        .then(function(responseData) {
          isCompleted = true;
          resolve(isCompleted);
        })
        .catch(function() {
          resolve(isCompleted);
        });
    });
  }
  
  function cancelFileUpload() {
    var isCompleted = false;
    uploadParamObject.fileParts = [];
    var completeParams: { [key: string]: any } = {};
    completeParams.uploadId = uploadParamObject.uploadId;
    completeParams.s3ObjectName = uploadParamObject.s3ObjectName;
    completeParams.documentId = uploadParamObject.documentId;
    return new Promise<boolean>(function(resolve, reject) {
      callMdaePublicApi({
        url: "/private/v1/documents/action/cancelupload",
        type: "POST",
        ...getDefaultOptions(),
        body: JSON.stringify(completeParams),
      })
        .then(function(responseData) {
          isCompleted = true;
          resolve(isCompleted);
        })
        .catch(function() {
          resolve(isCompleted);
        });
    });
  }
  function getCurrentProgressValue(isDownloadProgress) {
    var progressValue = 0;
    if (isDownloadProgress) {
      if (
        downloadParamObject.documentList &&
        downloadParamObject.documentList.length
      ) {
        progressValue =
          (downloadParamObject.currentDownloadFileIndex /
            downloadParamObject.documentList.length) *
          100;
        progressValue = parseInt(progressValue.toString());
      }
    } else {
      if (uploadParamObject.fileParts && uploadParamObject.fileParts.length) {
        progressValue =
          (uploadParamObject.currentPartIndex /
            uploadParamObject.fileParts.length) *
          100;
        progressValue = parseInt(progressValue.toString());
      }
    }
  
    return progressValue;
  }
  
  function hideProgressBar() {
    toggleProgressBarLoaderPopupVisible(false);
    setProgressBarLoaderPopupValue(0);
  }
  
  function setupWaitTime() {
    waitTimeSetupConfig.currentWaitTime = 0;
    uploadParamObject.waitTimeInterval = setInterval(function() {
      waitTimeSetupConfig.currentWaitTime += 1;
      if (waitTimeSetupConfig.currentWaitTime == 20) {
        clearInterval(uploadParamObject.waitTimeInterval);
        uploadParamObject.dispatch({
          type: TOGGLE_WAIT_TIME_MESSAGE_POPUP,
          data: { isWaitTimeMessagePopupVisible: true },
        });
      }
    }, 1000);
  }
  function deleteWaitTimeSetup() {
    uploadParamObject.dispatch({
      type: TOGGLE_WAIT_TIME_MESSAGE_POPUP,
      data: { isWaitTimeMessagePopupVisible: false },
    });
    clearInterval(uploadParamObject.waitTimeInterval);
  }
  
  function getPresignedUrlForFileDownload(
    s3ObjectName: string,
    originalFileName: string,
    isFilePreivew?: boolean
  ) {
    return new Promise<void>(function(resolve, reject) {
      resetUploadParams();
      uploadParamObject.s3ObjectName = s3ObjectName;
      uploadParamObject.totalFileSize = 0;
      uploadParamObject.requestVerb = "GET";
      if (!isFilePreivew) uploadParamObject.originalFileName = originalFileName;
      getPresignedUploadUrl().then(function() {
        delete uploadParamObject.originalFileName;
        resolve();
      });
    });
  }
  function getDocumentAsBlob(s3ObjectName, originalFileName) {
    return new Promise(function(resolve, reject) {
      getPresignedUrlForFileDownload(s3ObjectName, originalFileName, true).then(
        function() {
          fetch(uploadParamObject.uploadUrl, { method: "GET" })
            .then((res) => {
              if (!res.ok) {
                reject(res);
                return;
              }
              return res.blob();
            })
            .then(function(blobFile) {
              resolve(blobFile);
            });
        }
      );
    });
  }
  const previewDocumentFromBucket = function(s3ObjectName, originalFileName) {
    return new Promise<void>(function(resolve, reject) {
      resolve();
       window.open(
          "/utils/documentviewer?s3ObjectKey=" +
            s3ObjectName +
            (originalFileName ? "&fileName=" + originalFileName : ""),
          "",
        );
    });
  };
  
  const downloadDocumentFromBucket = function(s3ObjectName, originalFileName) {
    originalFileName = originalFileName.replace(/[,;]/g, '_');
    originalFileName = originalFileName.replace(/"/g, "'");
    return new Promise<void>(function(resolve, reject) {
      getPresignedUrlForFileDownload(s3ObjectName, originalFileName).then(
        function() {
          resolve();
          var anchor = document.createElement("a");
          $(anchor).attr("href", uploadParamObject.uploadUrl);
          $(anchor).attr("download", originalFileName);
          anchor.click();
        }
      );
    });
  };
 
  const readExcelFromBucket = function (s3ObjectName, originalFileName) {
    originalFileName = originalFileName.replace(/[,;]/g, "_");
    originalFileName = originalFileName.replace(/"/g, "'");
  
    return new Promise(function (resolve, reject) {
      getPresignedUrlForFileDownload(s3ObjectName, originalFileName).then(
        async function () {
          
            const url = uploadParamObject.uploadUrl;
  
            const response = await fetch(url);
            const blob = await response.blob();
            const arrayBuffer = await blob.arrayBuffer();
  
            const workbook = XLSX.read(arrayBuffer, { type: "array" });
  
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
  
            const rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
  
            resolve(rows); 
        }
      );
    });
  };
  var downloadParamObject = {
    currentDownloadFileIndex: 0,
    downloadedFileBlobList: [],
    documentList: [],
  };
  var progressBarSettings = {
    dispatch: null,
  };
  function showProgressBar(
    isDownloadProgress = false,
    progressLoadIndicatorProgressText = "Uploading"
  ) {
    if(uploadParamObject.enableProgressBar)
      toggleProgressBarLoaderPopupVisible(true, progressLoadIndicatorProgressText);
    setProgressBarLoaderPopupValue(getCurrentProgressValue(isDownloadProgress));
  }
  function downloadMultipleDocuments() {
    return new Promise<void>(function(resolve, reject) {
      var downloadFileName =
        downloadParamObject.documentList[
          downloadParamObject.currentDownloadFileIndex
        ].documentName +
        "." +
        downloadParamObject.documentList[
          downloadParamObject.currentDownloadFileIndex
        ].fileType;
      getDocumentAsBlob(
        downloadParamObject.documentList[
          downloadParamObject.currentDownloadFileIndex
        ].s3ObjectName,
        downloadFileName
      ).then(function(blobFile) {
        downloadParamObject.downloadedFileBlobList.push({
          downloadFileName: downloadFileName,
          blobFile: blobFile,
        });
        downloadParamObject.currentDownloadFileIndex++;
        showProgressBar(true, "Downloading");
        if (
          downloadParamObject.currentDownloadFileIndex <
          downloadParamObject.documentList.length
        ) {
          downloadMultipleDocuments().then(function() {
            resolve();
          });
        } else {
          resolve();
        }
      });
    });
  }
  
  var currentDownloadFileIndex = 0;
  var downloadedFileBlobList = [];
  const beforeWindowUnloadEventHandler = (event) => {
    event.preventDefault();
    return (event.returnValue = "Upload is in progress");
  };
  const windowUnloadEventHandler = (event) => {
    Cookie.set("isUiBulkOperationInProgress", false);
  };
  const startBulkOperation = () => {
    window.addEventListener("beforeunload", beforeWindowUnloadEventHandler);
    window.addEventListener("unload", windowUnloadEventHandler);
    Cookie.set("isUiBulkOperationInProgress", true);
  };
  const endBulkOperation = () => {
    window.removeEventListener("beforeunload", beforeWindowUnloadEventHandler);
    window.removeEventListener("unload", windowUnloadEventHandler);
    setTimeout(() => {
      Cookie.set("isUiBulkOperationInProgress", false);
    }, 80000);
  };
  const downloadDocumentInBulk = function(
    documentList,
    dispatch,
    downloadFileName
  ) {
    return new Promise<void>(function(resolve, reject) {
      downloadParamObject.documentList = documentList;
      downloadParamObject.downloadedFileBlobList = [];
      downloadParamObject.currentDownloadFileIndex = 0;
      progressBarSettings.dispatch = dispatch;
      startBulkOperation();
      showProgressBar(true, "Downloading");
      downloadMultipleDocuments().then(function() {
        var jsZip = new jszip();
        for (
          var i = 0;
          i < downloadParamObject.downloadedFileBlobList.length;
          i++
        ) {
          jsZip.file(
            downloadParamObject.downloadedFileBlobList[i].downloadFileName,
            downloadParamObject.downloadedFileBlobList[i].blobFile
          );
        }
        jsZip.generateAsync({ type: "blob" }).then(function(content) {
          hideProgressBar();
          resolve();
          var anchor = document.createElement("a");
          $(anchor).attr("href", URL.createObjectURL(content));
          $(anchor).attr("download", downloadFileName + ".zip");
          anchor.click();
          endBulkOperation();
        });
      });
    });
  };
  
  /**
   * Returns a blob file and its content type for a given s3ObjectName and originalFileName.
   * @param s3ObjectName S3 object key/name
   * @param originalFileName Original file name
   * @returns Promise<{ blob: Blob, contentType: string }>
   */
  const getBlobFileFromS3 = function(
    s3ObjectName: string,
    originalFileName: string
  ): Promise<{ blob: Blob, contentType: string }> {
    return new Promise((resolve, reject) => {
      getDocumentAsBlob(s3ObjectName, originalFileName)
        .then((blobFile: any) => {
          resolve({
            blob: blobFile,
            contentType: blobFile.type
          });
        })
        .catch(reject);
    });
  };

  const getPresignedDownloadUrl = function(s3ObjectName: string): Promise<string> {
    return new Promise<string>(function(resolve, reject) {
      getPresignedUrlForFileDownload(s3ObjectName, "", true)
        .then(function() {
          resolve(uploadParamObject.uploadUrl);
        })
        .catch(reject);
    });
  };

  return {
    downloadDocumentFromBucket,
    previewDocumentFromBucket,
    uploadFile,
    downloadDocumentInBulk,
    readExcelFromBucket,
    getBlobFileFromS3,
    getPresignedDownloadUrl
  };
}
